import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';
import { parseEvidenceData, parseEvidenceDataToWordData } from '../../lib/utilityFunctions';

const initState = {
  selectedEvidenceCount: 0,
  requiredEvidenceCount: 0,
  evidenceData: [],
  wordData: [],
  isShaking: false,
  currentWordLayouts: [],
  pendingWordLayouts: [],
  wordCountInItem: 0,
  pendingWordCount: 0,
};

const evidenceReducer = (state = initState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INITIALIZE_STANDARD_ITEM: {
      const evidenceData = parseEvidenceData(payload.content);
      const { wordData, wordCountInItem } = parseEvidenceDataToWordData(evidenceData);

      return {
        ...state,
        selectedEvidenceCount: 0,
        requiredEvidenceCount: payload.requiredEvidenceCount,
        evidenceData,
        wordData,
        currentWordLayouts: [],
        pendingWordLayouts: [],
        wordCountInItem,
        pendingWordCount: 0,
      };
    }

    case REDUX_ACTIONS.DISABLE_EVIDENCE: {
      const { evidenceIndex } = payload;

      const newEvidenceData = [...state.evidenceData];
      const newEvidence = { ...newEvidenceData[evidenceIndex] };

      newEvidence.isDiscarded = true;
      newEvidence.isSelected = false;

      newEvidenceData[evidenceIndex] = newEvidence;

      const selectedEvidenceCount = state.selectedEvidenceCount - 1;

      return {
        ...state,
        evidenceData: newEvidenceData,
        selectedEvidenceCount,
      };
    }

    case REDUX_ACTIONS.TOGGLE_EVIDENCE_SELECTION: {
      const { evidenceIndex } = payload;

      const newEvidenceData = [...state.evidenceData];
      const newEvidence = { ...newEvidenceData[evidenceIndex] };

      newEvidence.isSelected = !newEvidence.isSelected;

      newEvidenceData[evidenceIndex] = newEvidence;

      const selectedEvidenceCount = newEvidence.isSelected ?
        state.selectedEvidenceCount + 1 : state.selectedEvidenceCount - 1;

      return {
        ...state,
        evidenceData: newEvidenceData,
        selectedEvidenceCount,
      };
    }

    case REDUX_ACTIONS.SET_IS_EVIDENCE_PANEL_SHAKING:
      return {
        ...state,
        isShaking: payload.isShaking,
      };

    case REDUX_ACTIONS.DESELECT_EVIDENCE:
      return {
        ...state,
        evidenceData: state.evidenceData.map(evidence => ({ ...evidence, isSelected: false })),
        selectedEvidenceCount: 0,
      };

    case REDUX_ACTIONS.REGISTER_TAGGABLE_WORD_LAYOUT: {
      const pendingWordLayouts = [...state.pendingWordLayouts];
      const { groupIndex, layout: { x, y, width, height } } = payload;
      const { text } = state.evidenceData[groupIndex];
      // remove underscores at the beginning of accessibility text
      const accessibilityLabel = text && [...text][0] === '_' ? text.substring(1) : text;
      const newGroup = {
        groupIndex,
        accessibilityLabel,
        rows: [],
      };

      if (pendingWordLayouts[groupIndex] !== undefined) {
        newGroup.rows = [...pendingWordLayouts[groupIndex].rows];
      }

      const affectedRowIndex = newGroup.rows.findIndex(e => e.y === y);

      if (affectedRowIndex < 0) {
        newGroup.rows.push({ x, y, width, height });
      } else {
        const newRow = newGroup.rows[affectedRowIndex];
        newGroup.rows[affectedRowIndex] = {
          ...newRow,
          width: newRow.width + width,
          x: Math.min(newRow.x, x),
        };
      }

      pendingWordLayouts[groupIndex] = newGroup;

      const currentWordLayouts = state.pendingWordCount + 1 >= state.wordCountInItem
        ? pendingWordLayouts.filter(Boolean) // remove empty elements
        : state.currentWordLayouts;

      return {
        ...state,
        pendingWordLayouts,
        pendingWordCount: state.pendingWordCount + 1,
        currentWordLayouts,
      };
    }

    default:
      return state;
  }
};

export default evidenceReducer;
